import API from "./_api_";

// ADD PARTNER
const addPartner = (data) => API.post("/partners/addPartner", data);

// GET ALL PARTNERS
const getAllPartners = () => API.get("/partners/getAllPartners");

// GET SINGLE PARTNER
const getSinglePartner = (slug) => API.get("/partners/getSinglePartner?slug=" + slug);

// UPDATE PARTNER
const updatePartner = (id, data) => API.patch("/partners/updatePartner?partnerId=" + id, data);

// DELETE PARTNER
const deletePartner = (id) => API.delete("/partners/deletePartner?partnerId=" + id);

export default { addPartner, getAllPartners, getSinglePartner, updatePartner, deletePartner };
